// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,

  // base_url: 'http://34.23.244.188:7054/admin',
  // image_url: 'http://34.23.244.188:7054/',
  // file_url : ' http://34.23.244.188:7054/uploads/csv/',
  // socketUrl: 'http://34.23.244.188:7054/',

  // base_url: 'http://localhost:7054/admin',
  // image_url: 'http://localhost:7054/',
  // file_url : ' http://localhost:7054/uploads/csv/',
  // socketUrl: 'http://localhost:7054/',

  base_url: 'https://be.travelchapel.com/admin',
  image_url: 'https://be.travelchapel.com/',
  socketUrl: 'https://be.travelchapel.com/',
  file_url : 'https://be.travelchapel.com/uploads/csv/',


    // base_url: 'http://202.131.117.92:7054/admin',
    // image_url: 'http://202.131.117.92:7054/',
    // socketUrl: 'http://202.131.117.92:7054/',
    // file_url : 'http://202.131.117.92:7054/uploads/csv/',
    chatNamespace: 'v8/xcode',
    imagePath: '../assets/img/pdfIcon.png',    
};


